// /**
//  * Parcel - Add
//  */

// React
import React, { useState, useContext, useEffect } from 'react'
// Context
import AuthContext from '../../../../authContext'

// react hook form
import { Controller, useForm } from 'react-hook-form'

// UI
import theme from '../../../../theme'
import {
  TextField,
  Grid,
  Button,
  CircularProgress,
  Paper,
  Typography,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  DialogContent,
  IconButton,
  DialogActions,
  Dialog,
  FormHelperText,
  Card,
  CardHeader,
  CardContent,
  Divider,
  FormControlLabel,
  Checkbox,
  withStyles,
  Tooltip,
  Theme
} from '@material-ui/core'
import Autocomplete from '@material-ui/lab/Autocomplete'
import Modal from '../../../../components/Modal'
import AddItemsParcelsList from './addItemsParcelsList'
import AddItemsParcelsForm from './addItemsParcelsForm'
import AddInventoryItemsParcelsForm from './addInventoryItemsParcelsForm'
import { MuiPickersUtilsProvider, DatePicker } from '@material-ui/pickers'
import jMoment from 'moment-jalaali'
import JalaliUtils from '@date-io/jalaali'

// Client SDK
import Client from 'client-sdk/src/client'
import { GetAllWarehousesRequestBuilder } from 'client-sdk/src/warehouses/warehouses'

// Type
import { ParcelItems, PayloadCreate, SelectorProps } from '../../interfaces'
import {
  AddItemCreateParcel,
  AddInventoryItemCreateParcel
} from '../../../parcels/interfaces'
import { Warehouse } from '../../../warehouses/interfaces'
import { courierNameProps, fulfillmentTypesProps } from './types'

// helpers'
import {
  flattenObject,
  removeEmptyValueObject,
  convertPersianDigit2English,
  checkHourisPast,
  disablePrevDateByHour
} from '../../../../utils/helpers'
import { Product } from '../../../products/interfaces'
import { Variant } from '../../../products/interfaces'
import { createParcelsActions } from '../../../parcels/actions'
import { connect } from 'react-redux'
import { compose } from 'redux'
import { createStructuredSelector } from 'reselect'
import { Store } from '../../../../redux/reducers'
import {
  makeSelectCountList,
  makeSelectError,
  makeSelectList,
  makeSelectLoading
} from '../../../parcels/selectors'

import { useHistory } from 'react-router-dom'
import moment from 'moment'
import DimensionsListInPage from '../../../orderPack/dimensionsListInPage'
import MapPosition from '../../../centers/components/mapPosition'
import classes from './add.module.scss'
import enviroment from 'client-sdk/src/enviroments/enviroment'
import RonadIcons from '../../../../components/iconComponent'
import { isWeekendDay } from '../../../../utils/Date/dayMethods'
import disableElement from '../../../../utils/disableElement'
import couriersFulfillmentTypes from 'client-sdk/src/parcels/couriersFulfillmentTypes'
import { useCutoffHandler } from '../../../../utils/hook/useGetCutoffListParcel'
import DimensionInputs from '../dimensionInputs'

jMoment.loadPersian({ dialect: 'persian-modern', usePersianDigits: true })
moment.locale('en')
const date = new Date()
const formattedDateNow = moment(date).format('YYYY-MM-DD')

type Props = {
  create: (body: any) => void
  onClose: () => void
  warehouseId: number
  createParcelsDispatch: (payload: PayloadCreate) => void
}

const HtmlTooltip = withStyles((theme: Theme) => ({
  tooltip: {
    backgroundColor: '#f5f5f9',
    color: 'rgba(0, 0, 0, 0.87)',
    maxWidth: 220,
    fontSize: theme.typography.pxToRem(12),
    border: '1px solid #dadde9'
  }
}))(Tooltip)

type Inputs = {
  agentName: string | null
  agentPhoneNumber: string | null
  deliveryDate: string
  pickAddress: string
  pickDate: string
  pickTime: string | null
  destinationId: number
  deliveryType: string
  id: number
  items: ParcelItems[]
  deliveryStartTime: string | null
  deliveryEndTime: string | null
  sourceId: number
  status: string
  courierId: number | null
  cutoffId: string | number
  description: string | null
  fulfillmentTypeId: null | number
  destinationWarehouseName: string
  inboundType: number | null
}

function useOnMount(handler: any) {
  return React.useEffect(handler, [])
}

function required(displayName: any) {
  return function validateRequired(value: any) {
    return value !== null || `${displayName} is required.`
  }
}

const inboundItems = [
  {
    name: 'shrink',
    label: 'شیرینک',
    info: 'در این سرویس تمامی کالا های موجود در محموله با استفاده از پلاستیک حرارت دیده روکش می‌شوند.',
    code: 'SHIRINK'
  },
  {
    name: 'labelAttachment',
    label: 'برچسب گذاری',
    info: 'لیبل و یا برچسب اختصاصی که میتواند شامل قیمت، لوگو و یا دیگر اطلاعات مورد نیاز شما باشد بر روی کالاها نصب میشود.',
    code: 'LABEL_ATTACHMENT'
  },
  {
    name: 'safety',
    label: 'ایمن سازی',
    info: 'در صورتی که کالای ارسال شده نیاز به اعمال تغییرات به صورت سطحی در ساختار دارند می‌توانید از این سرویس استفاده نمایید.',
    code: 'SAFETY'
  },
  {
    name: 'repackage',
    label: 'تغییر بسته‌بندی',
    info: 'در این سرویس کالاهای محموله میتواند در هنگام ورود بسته‌بندی شوند و یا تغیراتی در بسته‌بندی کالاها اعمال شود.',
    code: 'RE_PACKAGE'
  },
  {
    name: 'kitting',
    label: 'ترکیب چند قطعه',
    info: 'کیتینگ به معنی ساخت یک پکیج فروش با استفاده از چندین کالا است که میتواند به صورت مجزا ارسال شده و تحت عنوان یک کالا جای‌گذاری شود.',
    code: 'KITTING'
  }
]

const QCItems = [
  {
    name: 'productIdentification',
    label: 'هویت سنجی',
    info: 'با انتخاب این گزینه تمامی کالاهای موجود در محموله به صورت تک به تک مورد بررسی قرارمیگیرند',
    code: 'PRODUCT_IDENTIFICATION'
  },
  {
    name: 'checkDate',
    label: 'بررسی تاریخ تولید و انقضا',
    code: 'CHECK_DATE'
  },
  {
    name: 'test',
    label: 'بررسی عملکرد کالا',
    code: 'TEST'
  },
  {
    name: 'checkContents',
    label: 'بررسی محتویات کارتن',
    code: 'CHECK_CONTENTS'
  },
  {
    name: 'requestedQc',
    label: 'کنترل کیفی درخواستی',
    info: 'شما می‌توانید با انتخاب این گزینه کنترل کیفی مورد نظر خود را شخصی سازی نمایید',
    code: 'REQUESTED_QC'
  }
]

function Add(props: Props) {
  const features = JSON.parse(localStorage.getItem('profile') || '[]')

  const authContext = useContext(AuthContext)
  const history = useHistory()
  const {
    register,
    handleSubmit,
    errors,
    control,
    watch,
    setValue,
    formState: { isValid },
    getValues
  } = useForm<Inputs>({
    defaultValues: {
      deliveryType: '',
      agentPhoneNumber: null,
      agentName: null,
      deliveryDate: formattedDateNow,
      pickDate: disablePrevDateByHour(14),
      pickTime: null,
      cutoffId: null,
      deliveryStartTime: null,
      fulfillmentTypeId: null,
      deliveryEndTime: null,
      description: null,
      inboundType: null
    }
  })

  const [deliveryType, setDeliveryType] = useState<any>('BOX')
  const [transportationType, setTransportationType] = useState<any>()
  const [itemDeleted, setItemDeleted] = useState<any>({})
  const [id, setId] = useState<any>(1)
  const [itemsInfo, setItemsInfo] = useState<any>([])
  const [openAddItem, setOpenAddItem] = useState(false)
  const [openConfirmDelete, setOpenConfirmDelete] = useState(false)
  const [openAutocomplete, setOpenAutocomplete] = React.useState(false)
  const [locationModal, setLocationModal] = useState(false)
  const [addressModal, setAddressModal] = useState(false)
  const [destinationId, setDestinationId] = useState(
    enviroment.destinationId as number
  )
  const [valueWarehouse, setValueWarehouse] = React.useState<Warehouse | null>(
    null
  )
  const [checkSubmit, setCheckSubmit] = React.useState(false as boolean)
  const [parcelsData, setParcelsData] = React.useState({})
  const [options, setOptions] = React.useState<Warehouse[]>([])
  const [openDimensions, setOpenDimensions] = useState(false as boolean)
  const [tab, setTab] = useState(1)
  const [packageChoice, setPackageChoice] = useState<string[]>([])
  const [dimensions, setDimensions] = useState<any>([])
  const [latLng, setLatLng] = useState({ lat: 0, lng: 0 } as {
    lat: number
    lng: number
  })
  const [inboundDescription, setInboundDescription] = useState<string>('')
  const [qcDescription, setQcDescription] = useState<string>('')
  const loading = openAutocomplete && options.length === 0
  const values = getValues()

  const [listCourierName, setListCourierName] = useState<any>([])
  const [listFulfillmentTypes, setListFulfillmentTypes] = useState<any>([])
  const [addressDisabled, setAddressDisabled] = useState(false)
  const [extraServices, setExtraServices] = useState(false)
  const [dateInDatePiker, setDateInDatePiker] = useState(formattedDateNow)
  const [isParcelPackageRequired, SetIsParcelPackageRequired] = useState(false)

  const courierId = watch('courierId')
  const cutoffId = watch('cutoffId')
  const deliveryDate = watch('deliveryDate')
  const fulfillmentTypeId = watch('fulfillmentTypeId')

  const typePostingByMyself = listFulfillmentTypes.length > 0

  const fulfillmentTypeIdIsValid = typePostingByMyself
    ? fulfillmentTypeId
    : null

  const { listCutoff, handlerHolidays } = useCutoffHandler({
    courierId,
    dateSelected: deliveryDate,
    fulfillmentTypeId: fulfillmentTypeIdIsValid,
    entityName: 'parcel',
    setDateInDatePiker,
    setValue
  })

  useEffect(() => {
    let active = true
    if (!loading) {
      return undefined
    }
    ;(async () => {
      const token = localStorage.getItem('token') || ''
      const makeRequest = new GetAllWarehousesRequestBuilder()
        .params({
          'status.equals': 'ACTIVE',
          size: 100
        })
        .build()
      const client = new Client(token)
      const response = await client.execute(makeRequest)
      const warehouses = response.data as any
      if (active) {
        setOptions(warehouses as Warehouse[])
      }
    })()

    return () => {
      active = false
    }
  }, [loading])

  useEffect(() => {
    if (!openAutocomplete) {
      setOptions([])
    }
  }, [openAutocomplete])

  useEffect(() => {
    if (values.inboundType == 'VIP') {
      setPackageChoice([])
    }
  }, [values.inboundType])

  useEffect(() => {
    let totalCount: any = 0
    dimensions.forEach((dimension: any) => {
      totalCount += Number(dimension.count)
    })
  }, [dimensions])

  const handleCloseDimensions = () => {
    setOpenDimensions(false)
    setDimensions([])
  }

  const onSubmit = (data: Inputs) => {
    let ronadTransportationDTO,
      deliveryStartTime,
      deliveryEndTime,
      parcelCustomizedOperationDTO
    let {
      agentName,
      agentPhoneNumber,
      deliveryDate,
      pickAddress,
      pickDate,
      pickTime,
      description,
      inboundType
    } = data

    const items = itemsInfo.map((item: any) => {
      return {
        variantId: item.variant.id,
        productId: item.product.id,
        count: item.count,
        packageCount: item.boxCount ?? 1,
        packageAmount: item.packageAmount,
        inventoryItems: item.inventoryItems
      }
    })

    ronadTransportationDTO = {
      lat: latLng.lat,
      lon: latLng.lng,
      pickAddress,
      pickDate
      // pickTime: pickTime?.substring(0, 2).concat(':00:00')
    }

    parcelCustomizedOperationDTO = {
      shrink: packageChoice.indexOf('shrink') !== -1,
      labelAttachment: packageChoice.indexOf('labelAttachment') !== -1,
      safety: packageChoice.indexOf('safety') !== -1,
      repackage: packageChoice.indexOf('repackage') !== -1,
      kitting: packageChoice.indexOf('kitting') !== -1,
      productIdentification:
        packageChoice.indexOf('productIdentification') !== -1,
      checkDate: packageChoice.indexOf('checkDate') !== -1,
      test: packageChoice.indexOf('test') !== -1,
      checkContents: packageChoice.indexOf('checkContents') !== -1,
      requestedQc: packageChoice.indexOf('requestedQc') !== -1,
      inboundDescription,
      qcDescription
    }

    addParcel({
      agentName: agentName ? agentName : null,
      agentPhoneNumber: agentPhoneNumber ? agentPhoneNumber : null,
      deliveryType,
      items,
      courierId,
      cutoffId,
      partnerId: authContext?.user?.partnerId,
      deliveryDate,
      // transportationType,
      description,
      ronadTransportationDTO: addressDisabled ? ronadTransportationDTO : null,
      deliveryStartTime,
      deliveryEndTime,
      fulfillmentTypeId,
      destinationId,
      inboundType,
      shippingDate: convertPersianDigit2English(moment().format('YYYY-MM-DD')),
      parcelCustomizedOperationDTO,
      origin: 'RONAD_PANEL'
    })
  }

  const addParcel = (body: any) => {
    setParcelsData(body)
    handleOpenCheckConfirm()
  }

  const createItemsToParcels = (body: AddItemCreateParcel) => {
    const {
      count,
      product,
      variant,
      boxCount,
      category,
      countOfBox,
      hasExpirationDate,
      unitCost,
      productionDate,
      expirationDate
    } = body
    setId(id + 1)
    const idItem = product?.id
    const name = product?.name
    const dupItem = itemsInfo.filter((item) => item.variant.id === variant?.id)
    if (dupItem.length > 0) {
      const newItems = itemsInfo.map((item) => {
        if (item.variant.id === variant?.id) {
          return {
            ...item,
            count: Number(item.count) + Number(count),
            packageAmount: Number(count + item.count),
            inventoryItems: [
              {
                amount: Number(+count + +item.count),
                unitCost: +unitCost,
                productionDate: hasExpirationDate ? productionDate : null,
                expirationDate: hasExpirationDate ? expirationDate : null
              }
            ]
          }
        }
      })
      setItemsInfo(newItems)
    } else {
      setItemsInfo([
        ...itemsInfo,
        {
          id,
          productId: idItem,
          count,
          name,
          boxCount,
          countOfBox,
          product,
          packageAmount: countOfBox ?? Number(count),
          variant,
          inventoryItems: [
            {
              amount: Number(count),
              unitCost: unitCost ?? 0,
              productionDate: hasExpirationDate ? productionDate : null,
              expirationDate: hasExpirationDate ? expirationDate : null
            }
          ]
        }
      ])
    }
    setOpenAddItem(false)
  }

  const setConfirmDelete = (body: any) => {
    setOpenConfirmDelete(true)
    setItemDeleted(body)
  }

  const handleOpenCheckConfirm = () => {
    if (transportationType === 'PARTNER') {
      setCheckSubmit(true)
    } else {
      setOpenDimensions(true)
    }
  }

  const handleCloseCheckConfirm = () => {
    setCheckSubmit(false)
  }

  const handleClose = () => {
    setOpenConfirmDelete(false)
    setCheckSubmit(false)
  }

  const deleteItemsToParcels = () => {
    const newValueInfo = itemsInfo.filter((item: any) =>
      item.variantId
        ? item.variantId !== itemDeleted.variant.id
        : item.productId !== itemDeleted.productId
    )

    setItemsInfo(newValueInfo)
    setOpenAddItem(false)
    handleClose()
  }

  const handleCreateParcel = () => {
    const parcelData = { ...parcelsData, parcelPackages: dimensions }
    props.createParcelsDispatch({
      body: parcelData,
      pagination: {
        sourceWarehouseId: { equals: authContext.user?.warehouseId }
      },
      callback: () => {
        setParcelsData({})
        history.push('/parcels-sender')
      }
    })
    handleCloseDimensions()
    setCheckSubmit(false)
  }

  const handleDeliveryDateChange = (date: any) => {
    setValue(
      'deliveryDate',
      convertPersianDigit2English(date.format('YYYY-MM-DD'))
    )
    setValue('pickTime', '')
  }

  useOnMount(() => {
    register(
      { name: 'deliveryDate', type: 'text' },
      { validate: required('تاریخ تحویل را وارد کنید') }
    )
    register({ name: 'pickDate', type: 'text', defaultValue: '' })
    register({ name: 'pickTime', type: 'text', defaultValue: '' })
  })

  const handleChange = (event) => {
    const index = packageChoice.indexOf(event.target.name)
    if (index > -1) {
      const newChoises = [...packageChoice]
      newChoises.splice(index, 1)
      setPackageChoice(newChoises)
    } else {
      setPackageChoice([...packageChoice, event.target.name])
    }
  }

  const isFeatureDisable = (code: string) => {
    if (features && features.length > 0) {
      const feature = features.indexOf(code)
      return feature == -1
    }
    return false
  }

  useEffect(() => {
    const handlerFulfillmentTypes = async () => {
      const { res, ok }: any = await couriersFulfillmentTypes('parcel')
      if (ok) {
        setListCourierName(res)
      }
    }
    handlerFulfillmentTypes()
  }, [])

  useEffect(() => {
    if (courierId) {
      const res = listCourierName.find(
        (item: any) => item.courierId === courierId
      )
      if (res.fulfillmentTypes?.length === 0) {
        setAddressDisabled(!res.addressDisabled)
        setExtraServices(!res.extraServices)
        SetIsParcelPackageRequired(res.isParcelPackageRequired)
        setValue('fulfillmentTypeId', null)
        setValue('cutoffId', '')
      }
      setListFulfillmentTypes(res.fulfillmentTypes)
    }
  }, [courierId])

  useEffect(() => {
    if (listFulfillmentTypes.length > 0) {
      const res = listFulfillmentTypes.find(
        (item: any) => item.id === fulfillmentTypeId
      )
      SetIsParcelPackageRequired(res.isParcelPackageRequired)
      setAddressDisabled(!res.addressDisabled)
      setExtraServices(!res.extraServices)
    }
  }, [fulfillmentTypeId])

  const onSubmitHandler = (data: Inputs) => {
    setCheckSubmit(true)
  }
  const handlerSubmit = () => {
    if (!isValid) {
      handleSubmit(onSubmitHandler)()
    } else {
      setCheckSubmit(true)
    }
  }
  return (
    <>
      <Typography variant='h6' component='h2' style={{ marginBottom: '24px' }}>
        <Button onClick={() => history.goBack()}>
          <RonadIcons name='chevronRight' />
        </Button>
        ایجاد محموله
      </Typography>

      <form onSubmit={handleSubmit(onSubmit)} className={classes.formWrapper}>
        <Typography className={classes.typographyCards}>
          اطلاعات محموله
        </Typography>
        <Card className={classes.card}>
          <CardContent>
            <Grid container spacing={2}>
              <Grid item xs={3} sm={3} lg={3}>
                <div className={classes.item}>
                  <Controller
                    rules={{ required: true }}
                    style={{ width: '100%' }}
                    control={control}
                    name='courierId'
                    label='* نوع ارسال'
                    id='courierId'
                    as={
                      <TextField
                        variant='outlined'
                        select
                        fullWidth
                        error={!!errors.courierId && !!errors.courierId}
                      >
                        {listCourierName.map((item: courierNameProps) => (
                          <MenuItem
                            key={item.courierId}
                            value={item.courierId}
                            id={item.courierId}
                            // value='VIP'
                            // id='INBOUND_VIP'
                            disabled={isFeatureDisable('INBOUND_VIP')}
                          >
                            {item.courierName}
                          </MenuItem>
                        ))}
                      </TextField>
                    }
                  />
                </div>
                <FormHelperText error focused>
                  {errors?.courierId && ' نوع محموله الزامی میباشد'}
                </FormHelperText>
              </Grid>

              <Grid item xs={3} sm={3} lg={3}>
                <div className={classes.item}>
                  <Controller
                    // rules={{ required: true }}
                    style={{ width: '100%' }}
                    control={control}
                    name='fulfillmentTypeId'
                    label='* نوع ورود'
                    id='fulfillmentTypeId'
                    as={
                      <TextField
                        variant='outlined'
                        select
                        InputLabelProps={{
                          shrink: fulfillmentTypeId !== null
                        }}
                        disabled={!typePostingByMyself}
                        fullWidth
                        error={
                          !!errors.fulfillmentTypeId &&
                          !!errors.fulfillmentTypeId
                        }
                      >
                        {listFulfillmentTypes.map(
                          (item: fulfillmentTypesProps) => (
                            <MenuItem
                              value={item.id}
                              id={item.id}
                              disabled={isFeatureDisable('PICKUP_BY_PARTNER')}
                            >
                              {item.name}
                            </MenuItem>
                          )
                        )}
                      </TextField>
                    }
                  />
                </div>
              </Grid>
              <Grid item xs={3} sm={3} lg={3}>
                <div className={classes.item}>
                  <MuiPickersUtilsProvider utils={JalaliUtils} locale='fa'>
                    {/* <Controller
                      rules={{ required: true }}
                      name='deliveryDate'
                      id='deliveryDate'
                      control={control}
                      as={ */}
                    <DatePicker
                      inputVariant='outlined'
                      id='deliveryDate'
                      name='deliveryDate'
                      label='* تاریخ تحویل محموله'
                      minDate={dateInDatePiker}
                      format='jYYYY/jMM/jDD'
                      shouldDisableDate={(d: any) =>
                        typeof courierId === 'number'
                          ? handlerHolidays(d?._d)
                          : isWeekendDay(d?._d)
                      }
                      onChange={handleDeliveryDateChange}
                      fullWidth
                      disablePast
                      autoOk
                      okLabel='تأیید'
                      cancelLabel='لغو'
                      value={values.deliveryDate || null}
                      error={errors.hasOwnProperty('deliveryDate')}
                      helperText={
                        errors.deliveryDate && errors.deliveryDate.message
                      }
                    />
                    {/* }
                    /> */}
                  </MuiPickersUtilsProvider>
                </div>
                <FormHelperText error focused>
                  {errors?.deliveryDate && 'تاریخ تحویل محموله الزامی میباشد'}
                </FormHelperText>
              </Grid>

              <Grid item xs={3} sm={3} lg={3}>
                <div className={classes.item}>
                  <Controller
                    rules={{ required: true }}
                    style={{ width: '100%' }}
                    control={control}
                    name='cutoffId'
                    label={'* بازه تحویل محموله'}
                    id='cutoffId'
                    as={
                      <TextField
                        variant='outlined'
                        select
                        InputLabelProps={{
                          shrink: cutoffId !== ''
                        }}
                        fullWidth
                        error={!!errors.cutoffId && !!errors.cutoffId}
                      >
                        {listCutoff?.map((item: any) => (
                          <MenuItem
                            disabled={item.disableCutoff}
                            key={item.id}
                            value={item.id}
                            id={item.id}
                          >
                            {item.label}
                          </MenuItem>
                        ))}
                      </TextField>
                    }
                  />
                </div>
                <FormHelperText error focused>
                  {errors?.cutoffId && ' بازه تحویل محموله الزامی میباشد'}
                </FormHelperText>
              </Grid>

              {addressDisabled && (
                <>
                  <Grid item xs={9} alignItems='flex-end'>
                    <div className={classes.item}>
                      <div style={{ width: '100%' }}>
                        <TextField
                          variant='outlined'
                          fullWidth
                          name='pickAddress'
                          id='pickAddress'
                          label='آدرس جمع آوری'
                          inputRef={register({
                            required: 'آدرس جمع‌آوری الزامی است'
                          })}
                          error={errors.pickAddress && true}
                          helperText={errors.pickAddress?.message}
                        />
                      </div>
                    </div>
                  </Grid>
                  <Grid item xs={3} sm={3} lg={3} spacing={2}>
                    <div className={classes.item}>
                      <Button
                        style={{
                          height: '56px',
                          width: '100%',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'space-between'
                        }}
                        variant='outlined'
                        size='large'
                        component='span'
                        color='default'
                        onClick={() => setLocationModal(true)}
                      >
                        {latLng.lat == 0 ? (
                          <>
                            <span>اضافه کردن موقعیت مکانی</span>
                            <RonadIcons
                              name='plusCircleOutline'
                              className='text-primary'
                              style={{ marginRight: '5px' }}
                            />
                          </>
                        ) : (
                          <>
                            <span>موقعیت شما با موفقیت ثبت شد</span>
                            <RonadIcons
                              name='checkCircle'
                              size={0.6}
                              className='text-green'
                              style={{ marginRight: '5px' }}
                            />
                          </>
                        )}
                      </Button>
                    </div>
                  </Grid>
                </>
              )}

              <Grid item xs={3} sm={3} lg={3}>
                <div className={classes.item}>
                  <div style={{ width: '100%' }}>
                    <TextField
                      variant='outlined'
                      fullWidth
                      type='text'
                      id='agentName'
                      name='agentName'
                      label={
                        transportationType === 'RONAD'
                          ? 'نام مسئول تحویل دهنده'
                          : 'نام مسئول حمل'
                      }
                      inputRef={register({
                        required: false
                      })}
                      error={errors.agentName && true}
                    />
                  </div>
                </div>
                <FormHelperText error focused>
                  {errors.agentName?.type === 'required' &&
                    'نام مسئول الزامی می باشد'}
                </FormHelperText>
              </Grid>
              <Grid item xs={3} sm={3} lg={3}>
                <div className={classes.item}>
                  <div style={{ width: '100%' }}>
                    <TextField
                      variant='outlined'
                      fullWidth
                      type='text'
                      id='agentPhoneNumber'
                      name='agentPhoneNumber'
                      label={
                        transportationType === 'RONAD'
                          ? 'شماره مسئول تحویل دهنده(۰۹۱۲۱۲۳۴۵۶۷)'
                          : 'شماره مسئول حمل(۰۹۱۲۱۲۳۴۵۶۷)'
                      }
                      inputRef={register({
                        required: false,
                        minLength: 11,
                        maxLength: 11,
                        pattern: /[0-9]/
                      })}
                      error={errors.agentPhoneNumber && true}
                    />
                  </div>
                </div>
                <FormHelperText error focused>
                  {(errors?.agentPhoneNumber?.type === 'minLength' ||
                    errors?.agentPhoneNumber?.type === 'maxLength') &&
                    'شماره همراه ۱۱ رقم میباشد'}
                </FormHelperText>
                <FormHelperText error focused>
                  {errors.agentPhoneNumber?.type === 'required' &&
                    'شماره‌ همراه مسئول حمل الزامی می باشد'}
                </FormHelperText>
                <FormHelperText error focused>
                  {errors.agentPhoneNumber?.type === 'pattern' &&
                    'کیبورد خود را انگلیسی کنید'}
                </FormHelperText>
              </Grid>
              <Grid item xs={6} sm={6} lg={6}>
                <div className={classes.item}>
                  <TextField
                    variant='outlined'
                    fullWidth
                    inputRef={register({ required: false })}
                    name='description'
                    label='توضیحات'
                    id='warehouseAddress'
                  />
                </div>
              </Grid>
              <Grid item md={12} sm={12}>
                <div className='notif' style={{ marginTop: '8px' }}>
                  <RonadIcons
                    name='information'
                    size={0.7}
                    style={{ color: '#43778E' }}
                  />
                  <Typography style={{ marginRight: '10px', fontSize: '14px' }}>
                    در اینباند ویژه کالاهای موجود در محموله حداکثر تا 3 ساعت
                    کاری جای‌گذاری شده و با تعرفه ویژه محاسبه می‌شوند.
                  </Typography>
                </div>
              </Grid>
              <Grid item md={12} sm={12}>
                <div className='notif' style={{ marginTop: '4px' }}>
                  <RonadIcons
                    name='information'
                    size={0.7}
                    style={{ color: '#43778E' }}
                  />
                  <Typography style={{ marginRight: '10px', fontSize: '14px' }}>
                    آدرس انبار: تهران، محله شادآباد، خیابان ١٧ شهریور، بین شهدای
                    اسلامی و بسیج مستضعفین، پلاک 344 کدپستی: 1378795599{' '}
                    <span
                      onClick={() => setAddressModal(true)}
                      className='link'
                    >
                      نمایش لوکیشن
                    </span>
                  </Typography>
                </div>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
        <Typography className={classes.typographyCards}>خدمات مازاد</Typography>
        <Card className={classes.card}>
          <CardContent style={{ padding: '0 0 12px 0' }}>
            <ul className={classes.tabContainer}>
              <li
                onClick={() => setTab(1)}
                className={
                  classes.tabItems + ' ' + (tab == 1 && classes.active)
                }
              >
                اینباند
              </li>
              <li
                onClick={() => setTab(2)}
                className={
                  classes.tabItems + ' ' + (tab == 2 && classes.active)
                }
              >
                کنترل کیفی
              </li>
            </ul>
            {tab == 1 && (
              <Grid
                container
                justifyContent='space-between'
                style={{ marginTop: '24px' }}
              >
                {inboundItems.map((item) => (
                  <Grid item>
                    <FormControlLabel
                      control={
                        <Checkbox
                          onChange={handleChange}
                          checked={packageChoice.includes(item.name)}
                          name={item.name}
                          color='primary'
                          disabled={
                            extraServices || isFeatureDisable(item.code)
                          }
                          size='small'
                        />
                      }
                      label={
                        <div
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            columnGap: '10px'
                          }}
                        >
                          <Typography
                            style={{
                              fontSize: '16px',
                              fontWeight: '400',
                              color:
                                extraServices || isFeatureDisable(item.code)
                                  ? '#bdbdbd'
                                  : 'rgba(47, 72, 88, 1)'
                            }}
                          >
                            {item.label}
                          </Typography>
                          <RonadIcons
                            name='information'
                            className='text-primary'
                            size={0.6}
                            title={item.info}
                          />
                        </div>
                      }
                    />
                  </Grid>
                ))}
                <Grid style={{ marginTop: '30px' }} item xs={12}>
                  <div className={classes.item}>
                    <TextField
                      variant='outlined'
                      fullWidth
                      name='inboundDescription'
                      placeholder='لطفا توضیحات مربوط به سرویس‌های انتخابی که می‌تواند در اجرای بهتر خدمات فوق کمک کند را وارد نمایید.'
                      label='توضیحات'
                      InputLabelProps={{
                        shrink: true
                      }}
                      id='inboundDescription'
                      value={inboundDescription}
                      onChange={(e) => setInboundDescription(e.target.value)}
                    />
                  </div>
                </Grid>
              </Grid>
            )}
            {tab == 2 && (
              <Grid
                container
                justifyContent='space-between'
                style={{ marginTop: '24px' }}
              >
                {QCItems.map((item) => (
                  <Grid item>
                    <FormControlLabel
                      control={
                        <Checkbox
                          onChange={handleChange}
                          checked={packageChoice.includes(item.name)}
                          name={item.name}
                          disabled={
                            extraServices || isFeatureDisable(item.code)
                          }
                          color='primary'
                          size='small'
                        />
                      }
                      label={
                        <div
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            columnGap: '10px'
                          }}
                        >
                          <Typography
                            style={{
                              fontSize: '16px',
                              fontWeight: '400',
                              color:
                                extraServices || isFeatureDisable(item.code)
                                  ? '#bdbdbd'
                                  : 'rgba(47, 72, 88, 1)'
                            }}
                          >
                            {item.label}
                          </Typography>
                          {item.info && (
                            <RonadIcons
                              name='information'
                              className='text-primary'
                              size={0.6}
                              title={item.info}
                            />
                          )}
                        </div>
                      }
                    />
                  </Grid>
                ))}
                <Grid style={{ marginTop: '30px' }} item xs={12}>
                  <div className={classes.item}>
                    <TextField
                      variant='outlined'
                      fullWidth
                      name='qcDescription'
                      placeholder='لطفا توضیحات مربوط به سرویس‌های انتخابی که می‌تواند در اجرای بهتر خدمات فوق کمک کند را وارد نمایید.'
                      label='توضیحات'
                      InputLabelProps={{
                        shrink: true
                      }}
                      id='qcDescription'
                      value={qcDescription}
                      onChange={(e) => setQcDescription(e.target.value)}
                    />
                  </div>
                </Grid>
              </Grid>
            )}
            <Grid container className='notif'>
              <RonadIcons
                name='information'
                size={0.7}
                style={{ color: '#43778E' }}
              />
              <Typography style={{ marginRight: '10px', fontSize: '14px' }}>
                درخواست‌های مورد نظر بر روی تمامی کالاهای محموله اعمال می گردد.
              </Typography>
            </Grid>
          </CardContent>
        </Card>
        {['65', '2', '119'].includes(authContext?.user?.partnerId) && (
          <>
            <Typography className={classes.typographyCards}>
              اطلاعات انبار مقصد
            </Typography>
            <Card className={classes.card}>
              <CardContent>
                <Grid container spacing={2}>
                  <Grid item xs={3} sm={3} lg={3} spacing={2}>
                    <div className={classes.item}>
                      <Autocomplete
                        style={{ width: '100%' }}
                        open={openAutocomplete}
                        onOpen={() => {
                          setOpenAutocomplete(true)
                        }}
                        onClose={() => {
                          setOpenAutocomplete(false)
                        }}
                        getOptionSelected={(option, value) =>
                          option.name === value.name
                        }
                        getOptionLabel={(option) => option.name}
                        options={options}
                        loading={loading}
                        onChange={(event: any, newValue: any | null) => {
                          setDestinationId(newValue?.id)
                          setValueWarehouse(newValue)
                        }}
                        renderInput={(params) => (
                          <TextField
                            variant='outlined'
                            {...params}
                            label='انبار مقصد'
                            inputRef={register({ required: false })}
                            name='admin'
                            id='admin'
                            InputProps={{
                              ...params.InputProps,
                              endAdornment: (
                                <React.Fragment>
                                  {loading ? (
                                    <CircularProgress
                                      color='inherit'
                                      size={20}
                                    />
                                  ) : null}
                                  {params.InputProps.endAdornment}
                                </React.Fragment>
                              )
                            }}
                          />
                        )}
                      />
                    </div>
                  </Grid>
                  <Grid item xs={9} sm={9} lg={9} spacing={2}>
                    <div className={classes.item}>
                      <TextField
                        variant='outlined'
                        fullWidth
                        // defaultValue={' '}
                        value={valueWarehouse ? valueWarehouse?.address : ''}
                        label='آدرس انبار'
                        inputProps={{ readOnly: true }}
                        id='warehouseAddress'
                      />
                    </div>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </>
        )}

        <Typography className={classes.typographyCards}>
          کالاهای محموله
        </Typography>
        <Card className={classes.card}>
          <CardContent>
            <Grid container justifyContent='flex-end'>
              <Button
                variant='outlined'
                color='primary'
                size='large'
                startIcon={
                  <RonadIcons
                    name='plusCircleOutline'
                    className='text-primary'
                  />
                }
                onClick={() => {
                  setOpenAddItem(true)
                }}
                id='addProduct'
              >
                {'افزودن کالا به محموله'}
              </Button>
            </Grid>
            <Grid container>
              {itemsInfo.length > 0 && (
                <AddItemsParcelsList
                  data={itemsInfo}
                  deleteItem={(body: any) => setConfirmDelete(body)}
                />
              )}
            </Grid>
          </CardContent>
        </Card>

        <Typography className={classes.typographyCards}>
          بسته های محموله
        </Typography>

        <DimensionInputs
          setDimensions={setDimensions}
          dimensions={dimensions}
          isParcelPackageRequired={isParcelPackageRequired}
        />

        <Grid container justifyContent='flex-end'>
          {disableElement(features) ? (
            <Button
              type='button'
              size='medium'
              id='saveParcel'
              variant='contained'
              color='primary'
              disabled
            >
              {'ذخیره محموله '}
            </Button>
          ) : (
            <Button
              type='submit'
              size='medium'
              id='saveParcel'
              variant='contained'
              onClick={handlerSubmit}
              color='primary'
              disabled={
                Object.keys(
                  flattenObject(removeEmptyValueObject({ ...watch() }))
                ).length === 0
              }
            >
              {'ذخیره محموله '}
            </Button>
          )}
        </Grid>
      </form>
      <Dialog open={props.loading} aria-labelledby='responsive-dialog-title'>
        <DialogContent>
          <Typography variant='h4' style={{ padding: '100px' }}>
            در حال ذخیره محموله
          </Typography>
          <div className={classes.loadingTitle}>لطفا منتظر بمانید</div>
          <div style={{ textAlign: 'center', marginBottom: '35px' }}>
            <CircularProgress size={58} />
          </div>
        </DialogContent>
      </Dialog>
      <Dialog
        open={openConfirmDelete}
        fullWidth
        onClose={handleClose}
        aria-labelledby='responsive-dialog-title'
      >
        <DialogContent>
          <div
            style={{
              position: 'absolute',
              left: '3px',
              top: '10px',
              zIndex: 10
            }}
          >
            {handleClose ? (
              <IconButton aria-label='close' onClick={handleClose}>
                <RonadIcons name='times' size={0.8} />
              </IconButton>
            ) : null}
          </div>

          <div
            className={classes.cancelTitle}
          >{`آیا از حذف ${itemDeleted.name} از محموله اطمینان دارید؟`}</div>
          <Divider style={{ width: '100%', margin: '16px 0  0' }} />
        </DialogContent>
        <DialogActions className={classes.actionsBox}>
          <Grid
            container
            spacing={2}
            justifyContent='center'
            style={{ textAlign: 'center', marginBottom: '8px' }}
          >
            <Grid item xs={12}>
              <Button
                style={{ margin: '8px' }}
                autoFocus
                onClick={handleClose}
                variant='outlined'
                color='primary'
                size='large'
                id='cancelRemove'
              >
                {'انصراف'}
              </Button>
              <Button
                variant='contained'
                onClick={deleteItemsToParcels}
                size='large'
                id='confirmRemove'
                color='primary'
              >
                {'حذف کالا'}
              </Button>
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>

      <Dialog
        open={checkSubmit && isValid}
        onClose={handleCloseCheckConfirm}
        aria-labelledby='responsive-dialog-title'
      >
        <DialogContent>
          <div
            style={{
              position: 'absolute',
              left: '3px',
              top: '10px',
              zIndex: 10
            }}
          >
            {handleClose ? (
              <IconButton aria-label='close' onClick={handleClose}>
                <RonadIcons name='times' size={0.8} />
              </IconButton>
            ) : null}
          </div>

          <div className={classes.cancelTitle}>
            {`آیا از ایجاد محموله مطمئن هستید؟`}
          </div>
          <Divider style={{ width: '100%', margin: '16px 0  0' }} />
        </DialogContent>
        <DialogActions className={classes.actionsBox}>
          <Grid
            container
            spacing={2}
            justifyContent='center'
            style={{ textAlign: 'center', marginBottom: '8px' }}
          >
            <Grid item xs={12}>
              <Button
                style={{ margin: '8px' }}
                autoFocus
                onClick={handleCloseCheckConfirm}
                variant='outlined'
                color='primary'
                size='large'
                id='cancelCreateParcel'
              >
                {'انصراف'}
              </Button>
              <Button
                variant='contained'
                onClick={handleCreateParcel}
                size='large'
                id='confirmCreateParcel'
                color='primary'
              >
                {'ذخیره محموله'}
              </Button>
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>
      <Dialog
        maxWidth='md'
        open={locationModal}
        onClose={() => setLocationModal(false)}
        aria-labelledby='responsive-dialog-title'
      >
        <DialogContent>
          <div
            style={{
              position: 'absolute',
              left: '3px',
              top: '10px',
              zIndex: 10
            }}
          >
            <IconButton
              aria-label='close'
              onClick={() => setLocationModal(false)}
            >
              <RonadIcons name='times' size={0.8} />
            </IconButton>
          </div>
          <MapPosition
            style={{ height: '400px', width: '500px' }}
            zoom={14}
            center={{ lat: 35.6892, lng: 51.389 }}
            position={latLng}
            setLatlng={(latLng: { lat: number; lng: number }) => {
              setLatLng(latLng)
            }}
          />
          <Divider style={{ width: '100%', margin: '16px 0  0' }} />
        </DialogContent>
        <DialogActions className={classes.actionsBox}>
          <Grid
            container
            spacing={2}
            justifyContent='center'
            style={{ textAlign: 'center', marginBottom: '8px' }}
          >
            <Grid item xs={12}>
              <Button
                style={{ margin: '8px' }}
                onClick={() => setLocationModal(false)}
                variant='contained'
                color='primary'
                size='large'
                id='cancelCreateParcel'
              >
                {'تایید'}
              </Button>
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>
      <Dialog
        maxWidth='md'
        open={addressModal}
        onClose={() => setAddressModal(false)}
        aria-labelledby='responsive-dialog-title'
      >
        <DialogContent>
          <div
            style={{
              position: 'absolute',
              left: '3px',
              top: '10px',
              zIndex: 10
            }}
          >
            <IconButton
              aria-label='close'
              onClick={() => setAddressModal(false)}
            >
              <RonadIcons name='times' size={0.8} />
            </IconButton>
          </div>
          <MapPosition
            style={{ height: '400px', width: '500px' }}
            zoom={14}
            center={{ lat: 35.6700926, lng: 51.2933106 }}
            position={{ lat: 35.6700926, lng: 51.2933106 }}
            setLatlng={(latLng: { lat: number; lng: number }) => {
              setLatLng(latLng)
            }}
            readOnly
          />
          <Divider style={{ width: '100%', margin: '16px 0  0' }} />
        </DialogContent>
        <DialogActions className={classes.actionsBox}>
          <Grid
            container
            spacing={2}
            justifyContent='center'
            style={{ textAlign: 'center', marginBottom: '8px' }}
          >
            <Grid item xs={12}>
              <Button
                style={{ margin: '8px' }}
                onClick={() => setAddressModal(false)}
                variant='contained'
                color='primary'
                size='large'
                data-cy='cancelCreateParcel'
              >
                {'بستن'}
              </Button>
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>

      <Modal
        maxWidth='sm'
        onClose={() => setOpenAddItem(false)}
        open={openAddItem}
        title={
          <Typography
            variant='h6'
            style={{ textAlign: 'center', marginTop: '20px' }}
          >
            افزودن کالا به محموله
          </Typography>
        }
        content={
          <AddItemsParcelsForm
            addItem={(body: AddItemCreateParcel) => createItemsToParcels(body)}
            onClose={() => setOpenAddItem(false)}
          />
        }
      />
    </>
  )
}

const mapStateToProps = createStructuredSelector<Store, SelectorProps>({
  parcelsList: makeSelectList(),
  count: makeSelectCountList(),
  loading: makeSelectLoading(),
  error: makeSelectError()
})

function mapDispatchToProps(dispatch: Function) {
  return {
    createParcelsDispatch: (payload: PayloadCreate) =>
      dispatch(createParcelsActions(payload))
  }
}
const withConnect = connect(mapStateToProps, mapDispatchToProps)
export default compose(withConnect)(Add)
